import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  host: { class: 'conectio-brand' },
  selector: 'app-linkedin-callback',
  standalone: true,
  imports: [CommonModule, MatButtonModule, RouterModule, TranslateModule],
  templateUrl: './linkedin-callback.component.html',
  styleUrl: './linkedin-callback.component.scss'
})
export class LinkedinCallbackComponent {
  isTokenValid: boolean | null = null;

  constructor(private http: HttpClient, private router: Router) {
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window?.location?.search);
      const code = urlParams.get('code');
      if (code) {
        this.verifyCode(code);
      } else {
        this.isTokenValid = false;
      }
    }
  }  

  verifyCode(code: string) {

    const referredBy = document.cookie.split('; ').find(row => row.startsWith('referredBy='))?.split('=')[1];
    const name = document.cookie.split('; ').find(row => row.startsWith('name='))?.split('=')[1];
    const phone = document.cookie.split('; ').find(row => row.startsWith('phone='))?.split('=')[1];
    const offer = document.cookie.split('; ').find(row => row.startsWith('offer='))?.split('=')[1];
    const requestBody: any = { code: code };
    if (referredBy) {
      requestBody.referredBy = referredBy;
    }
    if (name) {
      requestBody.name = name;
    }
    if (phone) {
      requestBody.phone = phone;
    }
    if (offer) {
      requestBody.offer = offer;
    }
    
    this.http.post(`${environment.url}/api/linkedin/callback`, requestBody)
      .pipe(
        catchError(() => of(false))
      )
      .subscribe((response: any) => {
        if (response) {
          this.isTokenValid = true;
          document.cookie = `access_token=${response.access_token}; path=/;`;
          document.cookie = `referral_hash=${response.referral_hash}; path=/;`;
          document.cookie = `image_url=${response.image_url}; path=/;`;
          // Signed up with LinkedIn: drop any manual sign-up step left from an earlier attempt
          document.cookie = 'manualStep=; path=/; max-age=0';
          if (response.is_profiled) {
            this.router.navigate(['/session/candidate-profiling-success']);
          }
          else {
            this.continueRegister();
          }
          
        } else {
          this.isTokenValid = false;
        }
      });
  }

  continueRegister() {
    this.router.navigate(['/session/candidate-profiling']);
  }

}
